import React, { useState, useRef, useEffect } from 'react';
import { MoreVertical } from 'lucide-react';
import './RowActions.css';

function RowActions({ actions, id }) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const triggerRef = useRef(null);

  // Close on click outside
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target) &&
          triggerRef.current && !triggerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        setIsOpen(false);
        triggerRef.current?.focus();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  const validActions = actions.filter(Boolean);
  if (validActions.length === 0) return null;

  return (
    <div className="row-actions">
      <button
        ref={triggerRef}
        className="btn btn-icon row-actions-trigger"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        aria-haspopup="true"
        aria-expanded={isOpen}
        aria-label={`Actions for row ${id}`}
      >
        <MoreVertical size={16} />
      </button>

      {isOpen && (
        <div ref={menuRef} className="row-actions-menu" role="menu">
          {validActions.map((action, index) => {
            if (action.divider) {
              return <div key={`divider-${index}`} className="row-actions-divider" role="separator" />;
            }
            const Icon = action.icon;
            return (
              <button
                key={action.key}
                className={`row-actions-item ${action.variant === 'danger' ? 'row-actions-item--danger' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen(false);
                  action.onClick();
                }}
                disabled={action.disabled}
                role="menuitem"
              >
                {Icon && <Icon size={15} />}
                {action.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default RowActions;
